"use client";

import { useState, useEffect } from 'react';

const RING_ORDER = [0, 1, 2, 5, 8, 7, 6, 3];

interface BrailleSpinnerProps {
  size?: number;
  color?: string;
  label?: string;
}

export default function BrailleSpinner({ size = 28, color = '#3bd576', label = 'Loading data…' }: BrailleSpinnerProps) {
  const [frame, setFrame] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setFrame(f => (f + 1) % RING_ORDER.length), 100);
    return () => clearInterval(id);
  }, []);

  const dotSize = Math.round(size / 9);
  const gap = Math.round(size / 9);

  const activeIdx = RING_ORDER[frame];
  const trailIdx = RING_ORDER[(frame - 1 + RING_ORDER.length) % RING_ORDER.length];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '16px' }}>
      <div style={{
        display: 'grid',
        gridTemplateColumns: `repeat(3, ${dotSize}px)`,
        gap: `${gap}px`,
        userSelect: 'none',
      }}>
        {Array.from({ length: 9 }, (_, i) => {
          const isActive = i === activeIdx;
          const isTrail = i === trailIdx;
          const opacity = isActive ? 1 : isTrail ? 0.5 : 0.15;
          return (
            <div
              key={i}
              style={{
                width: dotSize,
                height: dotSize,
                borderRadius: '50%',
                backgroundColor: color,
                opacity,
                transition: 'opacity 0.1s ease',
              }}
            />
          );
        })}
      </div>
      {label && (
        <span className="animate-pulse" style={{ fontSize: 11, color: '#888', fontFamily: 'Arial, sans-serif' }}>
          {label}
        </span>
      )}
    </div>
  );
}
